import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { DoodShopModel } from '@core/models/shop.model';
import { SHOP_HERO_IMAGE_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { ShopHeroImageBlockScenarioContent } from '@front-platform/content-builder';

import {
  SHOP_HERO_IMAGE_BLOCK_LOADING_VM,
  ShopHeroImageBlockDataSource,
  ShopHeroImageBlockViewModel,
} from './shop-hero-image-block-view-model';

@Injectable()
export class ShopHeroImageBlockPreviewDataSource implements ShopHeroImageBlockDataSource {
  readonly vm$: Observable<ShopHeroImageBlockViewModel> = previewScenarioForBloc$(
    SHOP_HERO_IMAGE_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return SHOP_HERO_IMAGE_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<ShopHeroImageBlockScenarioContent>(
        scenario,
        SHOP_HERO_IMAGE_BLOCK_COMPONENT,
      );
      if (!content) {
        return SHOP_HERO_IMAGE_BLOCK_LOADING_VM;
      }
      return {
        shop: (content.shop as DoodShopModel | null) ?? null,
        isShopLoading: !!content.isShopLoading,
      };
    }),
  );
}
